import { useState, useEffect } from "react"
import { getPageKey, getReportId } from "lib/navigation.js"
import { useRouter } from "next/router"
import ResearchMenuLayout from "./researchMenuLayout"
import { EmptyResearchLayout } from "./emptyResearchLayout"
import { THEME } from "configs/theme"
import { getSubMenuConfig } from "lib/util"
import { useDashboardContext } from "context/dashboardContext"
import { isNullOrEmpty } from "@common/lib/util"
import SidePanelLayout, { Main, Side } from "@common/v2/layouts/sidePanelLayout"
import SideNav from "@common/v2/sideNav"
import { Header } from "@common/header/headerUnit"

//isCollapsible -> default false
export default function ResearchManageLayout({ children, isCollapsible = true }) {
  const router = useRouter()
  const subMenuConfig = THEME?.menus?.subMenuManage
  const { sourceList } = useDashboardContext()
  const latestMenuConfig = getSubMenuConfig(router.asPath, subMenuConfig, sourceList)
  const [menuConfig, setMenuConfig] = useState(() => latestMenuConfig)

  const pageKey = getPageKey(router.asPath, router.query)
  const reportId = getReportId()
  const selectedPageKey = pageKey == "stats" ? reportId || "tag" : pageKey

  useEffect(() => {
    if (!isNullOrEmpty(latestMenuConfig)) {
      setMenuConfig(latestMenuConfig)
    }
  }, [subMenuConfig, selectedPageKey, router])

  const config = menuConfig[0]

  return (
    <SidePanelLayout>
      <Side isCollapsible={true} show align="left" widthClass="w-48">
        <div className="px-2 pt-8 space-y-4">
          <Header variant="h7">
            <Header.ShortHeader color="secondary">{config?.name}</Header.ShortHeader>
          </Header>
          <SideNav
            config={config?.items}
            isCollapsed={false}
            selectedKey={selectedPageKey}
          />
        </div>
      </Side>
      <Main>{children}</Main>
    </SidePanelLayout>
  )
}

// context - read option 4 (bonus) here https://adamwathan.me/2019/10/17/persistent-layout-patterns-in-nextjs/
export const subMenuLayout = (page) => (
  <EmptyResearchLayout>
    <ResearchMenuLayout>
      <ResearchManageLayout>{page}</ResearchManageLayout>
    </ResearchMenuLayout>
  </EmptyResearchLayout>
)

// helps take in variable. in this case, menu config
// eslint-disable-next-line react/display-name
export const subMenuLayoutParams = (params) => (page) => {
  return (
    <EmptyResearchLayout>
      <ResearchMenuLayout>
        <ResearchManageLayout isCollapsible={params?.isCollapsible}>
          {page}
        </ResearchManageLayout>
      </ResearchMenuLayout>
    </EmptyResearchLayout>
  )
}
